import React, { Component } from 'react';
import _ from 'lodash';

import TinyNodeParkinglocationsModel from './TinyNodeParkinglocationsModel';

import { Select } from 'antd';
const Option = Select.Option;

class TinyNodeParkinglocationsSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {
    TinyNodeParkinglocationsModel.getAll()
      .then(data => {
        data = _.sortBy(data, ['parkingLocationName']);
        var children = [];
        data.map((child, key) => {
          return children.push(<Option key={child.id}>{child.parkingLocationName}</Option>);
        });
        this.setState({
          children: children
        });
      });
  }

  render() {
    return (
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte lokalitu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={(value) => { this.props.onChange(value) }}
        {...this.props}>
        {this.state.children}
      </Select>
    );
  }
}

export default TinyNodeParkinglocationsSelect;


// WEBPACK FOOTER //
// ./src/components/TinyNodeParkinglocationsSelect.js